<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.83234 0.81689C8.11772 0.290301 9.52494 0 11 0H22V8.79624L21.9995 8.80332V11.0001C21.9995 13.0728 21.4263 15.0116 20.4297 16.6666C18.5051 19.8625 15.0022 22 10.9995 22C5.9388 22 1.6765 18.5829 0.394003 13.93L0.392698 13.9234C0.136719 12.9925 0 12.0122 0 10.9999C0 6.39957 2.82343 2.45902 6.83234 0.81689ZM10.9995 20.0215C6.87649 20.0215 3.3951 17.2543 2.32042 13.4723L2.31995 13.4699L2.3004 13.3988C2.09097 12.6372 1.97851 11.8333 1.97851 10.9999C1.97851 7.22996 4.29097 3.99593 7.58239 2.6477C8.63384 2.21694 9.78658 1.97849 11 1.97849H20.0215V8.72874L20.021 8.73561V11.0001C20.021 12.7032 19.551 14.2904 18.7348 15.6459C17.1533 18.2722 14.28 20.0215 10.9995 20.0215Z"
              fill="#42B55B" />
        <path
            d="M16.563 8.86794C16.563 8.86794 17.285 8.23927 17.285 7.46377C17.285 6.68826 16.563 5.89258 16.563 5.89258L9.86473 12.9057L5.81257 8.8503C5.81257 8.8503 5.10645 9.23194 5.10645 10.2354C5.10646 11.0582 5.75823 11.6 5.75823 11.6L9.86473 15.714L16.563 8.86794Z"
            fill="#42B55B" />
    </svg>
</template>
<script>
export default {
    name: "FlowluLogo",
}
</script>
